import { post, put } from 'axios'
import { removeFakeEmail } from '@/helpers/mailFake'
import { fetchPersonSecret } from './auth'

const decodeJWT = require('jwt-decode')

const parseJwt = token => {
  try {
    const user = decodeJWT(token)
    return { ...user, email: removeFakeEmail(user.user) }
  } catch (e) {
    return false
  }
}

export const NewLayoutRules = {
  Legacy: 'legacy',
  NewLayout: 'new-layout',
}

export const defaultUser = {
  role: 'user',
  rules: [],
  reportMinimumUsers: process.env.VUE_APP_REPORT_MINIMUM_UNIQUE_USERS,
  email: '',
  profile: {},
  plan: 'basic',
  language: 'en-us',
  tenantName: 'none',
  // default layout rules
  earlyAccessTrialAccount: false,
  layoutRules: {
    'login-redirect': NewLayoutRules.Legacy,
    home: NewLayoutRules.Legacy,
    climate: NewLayoutRules.Legacy,
    culture: NewLayoutRules.Legacy,
    participation: NewLayoutRules.Legacy,
    'groups-comparison': NewLayoutRules.Legacy,
    benchmark: NewLayoutRules.Legacy,
    opinions: NewLayoutRules.Legacy,
    'action-plans': NewLayoutRules.Legacy,
    survey: NewLayoutRules.Legacy,
    'engagement-summary': NewLayoutRules.Legacy,
    'management-groups': NewLayoutRules.Legacy,
    'management-people': NewLayoutRules.Legacy,
  },
}

export const PLANS = {
  BASIC: 'basic',
  ENTERPRISE: 'enterprise',
  TRIAL: 'trial',
}

export const getUser = () => ({ ...defaultUser, ...parseJwt(localStorage.jwt) })

export const isToLegacy = context =>
  getUser().layoutRules[context] === NewLayoutRules.Legacy
export const isToNewLayout = context =>
  getUser().layoutRules[context] === NewLayoutRules.NewLayout
export const isEarlyAccessTrialAccount = () =>
  isTrialPlan() && getUser().earlyAccessTrialAccount

export const isBasicPlan = () => getUser().plan === PLANS.BASIC
export const isEnterprisePlan = () => getUser().plan === PLANS.ENTERPRISE
export const isTrialPlan = () => getUser().plan === PLANS.TRIAL
export const isUser = () => getUser().role === 'user'
export const isAdmin = () => getUser().role === 'admin'
export const isManager = () => getUser().role === 'manager'
export const isAdminOrManager = () =>
  ['admin', 'manager'].includes(getUser().role)
export const saveUserData = jwt => {
  localStorage.jwt = jwt
  window.dispatchEvent(new Event('update:jwt', getUser()))
}

let eventDispatched = false
export const refreshToken = async () => {
  if (!eventDispatched) {
    eventDispatched = true
    const response = await post('/auth/refresh-token')
    saveUserData(response.data.token)
    // eslint-disable-next-line require-atomic-updates
    eventDispatched = false
    window.location.reload(true)
  }
}

window.addEventListener('refreshToken', refreshToken, false)

export const toggleSignLanguage = body => put(`users/sign-language`, body)

export const generateCookie = async (expiresInSeconds = 30) => {
  const token = localStorage.jwt

  const {
    data: { personSecret },
  } = await fetchPersonSecret()

  // expire
  const expiresDate = new Date()
  expiresDate.setTime(expiresDate.getTime() + expiresInSeconds * 1000)

  const domain = 'teamculture.com.br'

  const options = [
    `expires=${expiresDate.toUTCString()}`,
    `path='/'`,
    `domain=${domain}`,
  ]

  // token
  const cookieToken = 't=' + token + '; ' + options.join('; ')
  document.cookie = cookieToken

  // person secret
  const cookiePersonSecret = 'p=' + personSecret + '; ' + options.join('; ')
  document.cookie = cookiePersonSecret
}

export default { defaultUser, getUser, toggleSignLanguage }
